export default __webpack_public_path__ + "static/media/HelveticaNeue-Medium.d9e8a4d9.woff2";